import type { KeyboardEvent } from 'react';

/** Enter envía; Shift+Enter inserta salto de línea. */
export function onChatEnterKey(
  event: KeyboardEvent<HTMLTextAreaElement>,
  onSend: () => void
): void {
  if (event.key !== 'Enter' || event.shiftKey) return;
  event.preventDefault();
  onSend();
}
